import { ChainId } from '@nominex/nomiswap-sdk'
import EthereumFarms from './1'
import OptimismFarms from './10'
import BscFarms from './56'
import GnosisFarms from './100'
import PolygonFarms from './137'
import ArbitrumFarms from './42161'
import AvalancheFarms from './43114'
import { SerializedFarmConfig } from './types'

export const getFarmsConfig = (chainId: ChainId): SerializedFarmConfig[] => {
  switch (chainId) {
    case ChainId.BSC:
      return BscFarms
    case ChainId.ETHEREUM:
      return EthereumFarms
    case ChainId.MATIC:
      return PolygonFarms
    case ChainId.OPTIMISM:
      return OptimismFarms
    case ChainId.GNOSIS:
      return GnosisFarms
    case ChainId.ARBITRUM:
      return ArbitrumFarms
    case ChainId.AVALANCHE:
      return AvalancheFarms
    default:
      return []
  }
}

export * from './helpers'
export * from './types'
